<template>
  <div id="app">
    <TheHeader />
    <main class="main-content">
      <router-view />
    </main>
    <TheFooter />
  </div>
</template>

<script>
  import TheHeader from "./components/layout/TheHeader.vue"
  import TheFooter from "./components/layout/TheFooter.vue"

  export default {
      name: 'app',
      components: { TheHeader, TheFooter },

      methods : {
        setMeta(route){
          // タイトルを設定
          if(route.meta.title){
            let setTitle = route.meta.title;
            document.title = setTitle;
          }
          // ディスクリプションを設定
          if(route.meta.desc){
            let setDesc = route.meta.desc;
            document.querySelector("meta[name='description']").setAttribute('content', setDesc)
          }
        }
      },
      mounted(){
        let route = this.$route;
        this.setMeta(route);
      },
      watch: { 
        '$route' (route) {
          this.setMeta(route);
        }
      }
  }
  
</script>



<style lang="scss">
@import '@/styles/global.scss';

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 80px; // ヘッダーの高さ分
  min-height: calc(100vh - 80px); // Ensure minimum height
  position: relative; // Ensure proper positioning context
  
  @include media-breakpoint-down(lg) {
    padding-top: 70px;
    min-height: calc(100vh - 70px);
  }
}

// ページトランジション
.page-enter-active,
.page-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.page-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.page-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
</style>
